import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import styled from './styled';
import { getSingleShiftApplicant } from 'helpers/api-calls/shift-calls';
import { isValidObject } from 'helpers/validation';

class UserCell extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      debug: false,
      coverer: null,
      displayParentApplicantCount: 0,
    };

    this.cancelFetch = false;
  }

  componentDidMount() {
    this.initializeUserInfo();
  }

  componentDidUpdate(prevProps) {
    if (this.isShift() && prevProps.user !== this.props.user) {
      this.fetchUserInfo();
    }
  }

  componentWillUnmount() {
    this.cancelFetch = true;
  }

  isShift = () => this.props.shift?.time_off_reason === undefined;

  initializeUserInfo = () => {
    const { shift } = this.props;
    if (this.isShift()) {
      this.fetchUserInfo();

      const { parent_card, cover_mode, current_applicants_approved_user_ids = [], current_applicants_denied_user_ids = [], current_applicants_pending_user_ids = [] } = shift;
      if (parent_card && cover_mode === 'multi_applicants_picked_by_manager') {
        const tempCount = current_applicants_approved_user_ids.length +
                          current_applicants_denied_user_ids.length +
                          current_applicants_pending_user_ids.length;
        if (tempCount > 0) {
          this.setState({ displayParentApplicantCount: tempCount });
        }
      }
    }
  };

  fetchUserInfo = () => {
    const { user, shift, isRequests } = this.props;
    
    if( isRequests ){
      this.fetchUserFromServer(user, shift);
    }else{
      this.fetchUserFromReducer(user, shift);
    }
  };

  fetchUserFromReducer = (user, shift) => {
    const {applicantsDictionary} = this.props;
    if( user?.applicantId > 0 && user?.applicantId == shift?.coverer?.applicantId ){
      const applicant = applicantsDictionary[user?.applicantId];
      if (applicant) {
        this.setCoverer({applicant: applicant});
      }
    }
  }

  fetchUserFromServer = (user, shift) => {
      if (user?.applicantId > 0 && user.first_name === '') {
      getSingleShiftApplicant(shift.id, user.applicantId)
        .then((response) => {
          if (!this.cancelFetch) {
            this.setCoverer(response.data);
          }
        })
        .catch((error) => {
          if (user.last_name.length === 2 && user.last_name.includes('#')) {
            this.setState({
              coverer: {
                id: 0,
                applicantId: user.applicantId,
                first_name: '-',
                last_name: '-',
                profile_image: '/icons/default-profile-thumb.svg',
              },
            });
          }
          console.error(`UserCell fetchUserInfo failed: ${error}`);
        });
    }
  }

  setCoverer = (data) => {
    const coverer = {
      applicantId: data.applicant.id,
      first_name: data.applicant.user.first_name,
      last_name: data.applicant.user.last_name,
      thumb_url: data.applicant.user.thumb_url || '/icons/default-profile-thumb.svg',
      badge_id: data.applicant.badge_id,
      available: data.applicant.available,
      position: data.applicant.user.current_position,
    };
    this.setState({ coverer });
  };

  renderBottomLine = (first, second, third, fourth) => (
    <styled.BottomLineWrap>
      {first && <styled.BottomLineText>{first}</styled.BottomLineText>}
      {first && second && <styled.Dot />}
      {second && <styled.BottomLineText>{second}</styled.BottomLineText>}
      {(first || second) && third && <styled.Dot />}
      {third && <styled.BottomLineText>{third}</styled.BottomLineText>}
      {(first || second || third) && fourth && <styled.Dot />}
      {fourth && <styled.BottomLineText>{fourth ? 'Available' : ''}</styled.BottomLineText>}
    </styled.BottomLineWrap>
  );

  renderUserShift = () => {
    const { user, hideApplicantCount } = this.props;
    const { debug, coverer, displayParentApplicantCount } = this.state;
    const tempUser = coverer || user;

    if (!user) {
      return (displayParentApplicantCount > 0 && hideApplicantCount == false) ? (
        <styled.TopWrap>
          <styled.OwnerInfoWrap>
            <styled.OwnerInfoTopLine>
              <styled.UserName>{`+${displayParentApplicantCount} applicants`}</styled.UserName>
            </styled.OwnerInfoTopLine>
          </styled.OwnerInfoWrap>
        </styled.TopWrap>
      ) : <styled.TopWrap />;
    }

    const userImageUrl = tempUser.thumb_url || tempUser.profile_image?.thumb_url || '/icons/default-profile-thumb.svg';
    const userName = `${tempUser.first_name} ${tempUser.last_name}`;
    const shouldDisplayUserName = !userName.includes('#a') && !userName.includes('#p') && !userName.includes('#d');

    return (
      <styled.TopWrap>
        {shouldDisplayUserName && (
          <>
            <styled.OwnerAvatar src={userImageUrl} rounded />
            <styled.OwnerInfoWrap>
              <styled.OwnerInfoTopLine>
                <styled.UserName>{userName}</styled.UserName>
                {tempUser.is_admin && <styled.ApprovedBadge src="/icons/verified-badge-icon.svg" />}
              </styled.OwnerInfoTopLine>
              {!debug && this.renderBottomLine(tempUser.position, tempUser.badge_id, '', '')}
            </styled.OwnerInfoWrap>
          </>
        )}
      </styled.TopWrap>
    );
  };

  renderTimeOff = () => {
    const { shift } = this.props;
    const { debug } = this.state;

    const userImageUrl = shift?.profile_image_thumb_url || '/icons/default-profile-thumb.svg';
    const userName = `${shift?.first_name} ${shift?.last_name}`;
    const bottomLineFirst = shift?.user_privilege_position || '';
    const bottomLineSecond = shift?.user_privilege_badge_id || '';

    return (
      <styled.TopWrap>
        <styled.OwnerAvatar src={userImageUrl} rounded />
        <styled.OwnerInfoWrap>
          <styled.OwnerInfoTopLine>
            <styled.UserName>{userName}</styled.UserName>
            {shift.is_admin && <styled.ApprovedBadge src="/icons/verified-badge-icon.svg" />}
          </styled.OwnerInfoTopLine>
          {!debug && this.renderBottomLine(bottomLineFirst, bottomLineSecond, '', '')}
        </styled.OwnerInfoWrap>
      </styled.TopWrap>
    );
  };

  render() {
    return this.isShift() ? this.renderUserShift() : this.renderTimeOff();
  }
}

UserCell.propTypes = {
  shift: PropTypes.object,
  user: PropTypes.object,
  locationId: PropTypes.number,
};

export default injectIntl(UserCell);
